import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import TableSpinnerIcon from "../../../Icon-SVG/TableSpinnerIcon";

import { RequestContainerServices } from "../../../../store/actions/containerActions";

import "./styles.scss";

const getPrefix = (responsible) => {
  if (!responsible) {
    return "";
  }
  const splittedByDash = responsible.split("-");
  const prefix = splittedByDash.length > 0 ? splittedByDash[0] : "";

  switch (prefix) {
    case "bk":
      return "BK";
    case "an":
      return "CR";
    case "pf":
      return "MG";
    case "sq":
      return "ND";
    case "ag":
      return "TH";
    default:
      return "-";
  }
};

const ContainerServices = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const containerServices = useSelector((state) => state.container.containerServices);
  const loading = useSelector((state) => state.container.containerServicesLoading);

  useEffect(() => {
    dispatch(RequestContainerServices());
  }, [dispatch]);

  const refreshHandler = () => {
    dispatch(RequestContainerServices());
  };

  const navigateToPageHandler = () => history.push("/containers");

  // Check if there's data
  const hasData = containerServices && containerServices.length > 0;

  return (
    <div className="container-services">
      {hasData && (
        <div className="container-services__header">
          <h2 className="container-services__header__heading">C. Services</h2>
          <div className="container-services__header__refresh" onClick={refreshHandler}>
            <TableSpinnerIcon
              className="container-services__spinner"
              customStyle={{ margin: "0", height: "20px" }}
              spin={loading}
            />
          </div>
        </div>
      )}
      {containerServices?.map((containerService, index) => (
        <div
          className="container-services__block border"
          key={index}
          onClick={navigateToPageHandler}>
          <div className="container-services__block--icon">
            {getPrefix(containerService.responsible)}
          </div>
          <p className="container-services__block--text" style={{ color: "white" }}>
            {containerService.name}
          </p>
          <div className="container-services__block--signal">
            <b
              className={`container-services__block--signal--status ${containerService.status}`}></b>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ContainerServices;